require('./productOffersItem.scss')
//@vendors
const React = require('react');
const PropTypes = require('prop-types');
//@utilities
const right_icon = require('assets/icons/red-right-icon.svg');
import { recordLinkV2 } from 'utilities/tagging'

const ProductOffersItem = ({ data, onClick, index }) => {
    const handleButtonClick = () => {
        recordLinkV2({
            ...data.tagging,
        });
        onClick(data);
    }
    const { subheading, title, subtitle, headline, buttonText, firstRateText, secondRateText, icon, months, backColor } = data;

    return (
        <dt className='offertransferitem'>
            <header className='offertransferitem__header' style={{ backgroundColor: backColor }}>
                <img src={icon} alt="" className='offertransferitem__icon' />
                <p className='offertransferitem__subheading'>
                    {subheading}
                    {months && <span className='offertransferitem__months'>&nbsp;{months}</span>}
                </p>
                <h1 className='offertransferitem__title'>{title}</h1>
                <p className='offertransferitem__subtitle'>{subtitle}</p>
            </header>
            <article className='offertransferitem__content'>
                <p className='offertransferitem__headline'>
                    {headline}
                </p>
                <p className='offertransferitem__tintae'>
                    <span className='offertransferitem__tae'>
                        {firstRateText}
                        <sup className='offertransferitem__taesup'>{index + 1}</sup>
                    </span >
                    <span className='offertransferitem__tin'>
                        {secondRateText}
                    </span>
                </p>
                <button className='offertransferitem__link' onClick={handleButtonClick}>
                    {buttonText}
                    <img src={right_icon} alt="" />
                </button>
            </article>
        </dt>
    );
};

ProductOffersItem.propTypes = {
    onClick: PropTypes.func,
}

module.exports.constructor = ProductOffersItem;
module.exports.ProductOffersItem = ProductOffersItem
